import { Pipe, PipeTransform } from '@angular/core';
import { RsmEvent } from 'src/app/models/rsm-event';

@Pipe({
  name: 'eventObjectType'
})
export class EventObjectTypePipe implements PipeTransform {
  
  transform(eventObject: RsmEvent): string {
    //return "?" + eventType + "?" + eventObject + "?";
    
    if(eventObject.evt_type == 1){ //device
      
      switch (eventObject.evt_object_type) {
        case 1:
          return "IO Device"
        
        case 2:
          return "AC Device"
        
        case 3:
          return "Analogue Device"
        
        case 4:
          return "Analogue IO Device"
        
        case 5:
          return "SNMP Device"
        
        case 6:
          return "Modbus Device"
        
        case 7:
          return "DLMS Device"
        
        case 8:
          return "Veeder Device"
        
        case 9:
          return "Other Device"
        
        case 10:
          return "GSM Device"
      
        default:
          break;
      }

    }

    else if(eventObject.evt_type == 2){ //port

      switch (eventObject.evt_object_type) {
        case 1:
          return "Digital Input"
      
        case 2:
          return "Digital Output"
      
        case 3:
          return "Analogue Input"
      
        case 4:
          return "Analogue Output"
      
        default:
          break;
      }

    }

    else if (eventObject.evt_type == 3){ //site.. but object type is not used for sites
      return ""
    }

    else if (eventObject.evt_type == 4){ //analogue
      
      switch (eventObject.evt_object_type) {
        case 3:
          return "Analogue Input"
      
        case 4:
          return "Analogue Output"
      
        default:
          break;
      }

    }
  }

}
